// Display.js
import React from 'react';

const Display = ({ videoUrls }) => {
    return (
        <div  style={{backgroundColor:"white"}}>
            {videoUrls.length > 0 ? (
                videoUrls.map((url, index) => (
                    <video key={index} src={url} controls width="300" style={{ margin: '10px' }} />
                ))
            ) : (
                <p>No videos available.</p>
            )}
        </div>
    );
};

export default Display;
